// import icons
import {
  IoLogoYoutube,
  IoLogoFacebook,
  IoLogoInstagram,
  IoIosCheckmarkCircle,
  IoIosArrowRoundForward,
} from "react-icons/io";

// import images

import Features1Img from "./assets/img/features-1.jpg";
import Features2Img from "./assets/img/features-2.jpg";

import ChairImg from "./assets/img/chair.jpg";
import BedImg from "./assets/img/bed.jpg";
import CupboardImg from "./assets/img/cupboard.jpg";
import DinningImg from "./assets/img/dinning.jpg";
import StudyTableImg from "./assets/img/studytable.jpg";
import WardrobeImg from "./assets/img/wardrobe.jpg";
import TempleImg from "./assets/img/temple.jpg";
import WallImg from "./assets/img/wall.jpg";

import TestimonialImg from "./assets/img/testimonial.jpg";

import Avatar1Img from "./assets/img/avatar-1.png";
import Avatar4Img from "./assets/img/avatar-4.png";

export const navigation = [
  {
    name: "home",
    href: "home",
  },
  {
    name: "about",
    href: "about",
  },
  {
    name: "features",
    href: "features",
  },
  {
    name: "contact",
    href: "contact",
  },
];

export const hero = {
  title: "Creativity Meets Furniture Elegance",
};

export const stats = [
  {
    value: "21",
    text: "Year Experience",
  },
  {
    value: "200+",
    text: "Completed Projects",
  },
  {
    value: "10",
    text: "Industrial Machinery",
  },
  {
    value: "100+",
    text: "Variant Furniture",
  },
];

export const features = {
  image: <Features1Img />,
  title: "Enhance your home's beauty with our touch",
  subtitle:
    "Furnish your dreams with Furniture Power, the ultimate business management solution.",
  buttonText: "Show Now",
  items: [
    {
      icon: <IoIosCheckmarkCircle />,
      title: "Exceptional Quality, Affordable Luxury",
      subtitle:
        "Experience the perfect blend of luxury and affordability with our meticulously crafted furniture pieces.",
    },
    {
      icon: <IoIosCheckmarkCircle />,
      title: "Transform Your Bedroom into a Sanctuary",
      subtitle:
        "Find serenity and luxury in every piece of our bedroom furniture.",
    },
    {
      icon: <IoIosCheckmarkCircle />,
      title: "Unparalleled Customer Service and Satisfaction",
      subtitle:
        "Join our family of satisfied customers and enjoy a seamless shopping experience with our dedicated support team, committed to your complete satisfaction.",
    },
  ],
  feature2: {
    image: <Features2Img />,
    title: "The Best Furniture Manufacturer of your choice",
    subtitle:
      "Transform your home or office with our professional interior design services, curated to reflect your personality and lifestyle.",
  },
};

export const specialty = {
  title: "Our Specialty",
  subtitle: "Expert Craftsmanship: Transforming Spaces with Quality Furniture",
  link: "Check all",
  icon: <IoIosArrowRoundForward />,
  products: [
    {
      name: "Wardrobe",
      image: <WardrobeImg />,
    },
    {
      name: "bed",
      image: <BedImg />,
    },
    {
      name: "dinning",
      image: <DinningImg />,
    },
    {
      name: "cupboard",
      image: <CupboardImg />,
    },
    {
      name: "study area",
      image: <StudyTableImg />,
    },
    {
      name: "chair",
      image: <ChairImg />,
    },
    {
      name: "mandir",
      image: <TempleImg />,
    },
    {
      name: "wall design",
      image: <WallImg />,
    },
  ],
};

export const about = {
  title: "About Us",
  subtitle1:
    "HP Enterprises is one of the leading suppliers of High quality furniture in Pune, Maharashtra.",
  subtitle2:
    "Established in year 2003 by Hukmaram Punjaram Suthar & Bhagirath Punjaram Suthar.",
  subtitle3:
    "Interior Designer, Furniture Manufacturer, Distributor and Occupancy service provider of top quality furniture products.",
  description1:
    "Our products range is fabricated using superior quality raw material to ensure durability and long lasting performance. Our range of offering included Home Furniture, Office Furniture, Hotels & Restaurant Furniture, School Furniture etc. Our company is engaged in offering our services according to client's specific requirements and attains complete client satisfaction.",
  description2:
    "Our well-supported and equipped distribution network facilities us in supplying the orders of our clients within the stipulated time frame. We strive hard to offer the excellent quality products to our clients, which helps in attaining endless list of satisfied clients.",
};

export const testimonial = {
  title: "What people are saying about us",
  image: <TestimonialImg />,
  persons: [
    {
      avatar: <Avatar1Img />,
      name: "Shirish Khinwsara",
      occupation: "World of Titan, Chinchwad",
      message:
        "“They are have a perfect touch for make something so professional.”",
    },
    {
      avatar: <Avatar4Img />,
      name: "Kailash Tejani",
      occupation: "Hotel Dreamland, Mahabaleshwar",
      message:
        "“The quality of the furniture is superb and comments from our customers and visitors all positive. We'll be back for more. Thanks.”",
    },
    {
      avatar: <Avatar1Img />,
      name: "Dr. Manish Oswal",
      occupation: "Hospital",
      message:
        "“Their service from start to finish was great, with good quality!”",
    },
    {
      avatar: <Avatar4Img />,
      name: "Sanjay Shah",
      occupation: "Client",
      message:
        "“They designed my home in a way that not just looks good, but makes me desperate to come back home early.”",
    },
  ],
};

export const contact = {
  title: "Contact Us",
  subtitle: "Join our mailing list",
  placeholder: "Your email address",
  buttonText: "Shop Now",
  office:
    "Plot No. 25, Raviraj Society, Jambhulwadi Road, Dattanagar, Katraj, Pune-411046",
  Workshop: "Pansare Nagar, Yewalewadi, Kondhwa Budruk, Pune-411048",
  Email: "hpsuthar5@gmail.com",
  Mob1: {
    text: "+91 9860457148",
    call: "+919860457148",
  },
  Mob2: {
    text: "+91 9371012041",
    call: "+919371012041",
  },
};

export const footer = {
  social: [
    {
      icon: <IoLogoYoutube />,
      href: "https://youtube.com/shorts/JFrQBmLGiHM",
    },
    {
      icon: <IoLogoInstagram />,
      href: "https://www.instagram.com",
    },
    {
      icon: <IoLogoFacebook />,
      href: "https://www.facebook.com",
    },
  ],
  copyright: "HP ENTERPRISES 2024 - All Rights Reserved.",
};
